<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="6"
                lg="10"
                md="8"
                sm="6"
            >
                <h3>Users</h3>
            </v-col>
            <v-col 
                style="text-align: right;"
                cols="6"
                lg="2"
                md="4"
                sm="6"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            :to="{ name: 'userForm', params: {id: 0} }"
                        >
                            New User
                        </v-btn>
                    </template>
                    <span>New User</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-form @submit.prevent="getRegisters">
                    <v-text-field
                        v-model="filter.fastSearch"
                        label="Quick Search"
                        prepend-inner-icon="mdi mdi-magnify"
                        outlined
                        single-line
                        @click:prepend-inner="getRegisters"
                        dense
                    ></v-text-field>
                </v-form>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="filteredSearch"
                    :options.sync="options"
                    :loading="loading"
                    :items-per-page="10"
                    no-data-text="No Record Found"
                >
                    <template v-slot:item.statusDescription="{ item }">
                        <v-chip
                            :color="getStatusColor(item.statusDescription)"
                            outlined
                            dark
                        >
                            {{ item.statusDescription }}
                        </v-chip>
                    </template>
                    
                    <template v-slot:item.action="{item}">
                        <ActionList 
                            :id="item.id" 
                            :link="'userForm'"
                            :showButtons="{
                                edit: true,
                                delete: false,
                                cancel: item.status === 1 ? true : false,
                                active: item.status === 0 ? true : false,
                                approve: item.status === 3 ? true : false,
                                resetPassword: true
                            }"
                            @confirmCancel="confirmCancel"
                            @confirmActive="confirmActive" 
                            @confirmApprove="confirmApprove" />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <ActionDialog 
            v-on:methodConfirmToCall="dialog.methodConfirm"
            :showDialog.sync="dialog.show"
            :headerTitle="dialog.headerText"
            :bodyText="dialog.bodyText"
            :params="dialog.params"
        />

    </v-container>
</template>

<script>
    import Helpers from '@/utilities/Helpers';
    import ActionList from "@/components/Layout/ActionList";
    import ActionDialog from "@/components/Layout/ActionDialog";

    export default ({

        components: {
            ActionList: ActionList,
            ActionDialog: ActionDialog
        },

        mixins: [Helpers],

        data: () => ({

            loading: false,
            statusId: 0,

            filter: {
                fastSearch: ''
            },

            dialog: {
                show: false,
                headerText: "",
                bodyText: "",
                methodConfirm: ( () => {} ),
                params: null
            },

            headers: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "Profile", value: "profileName", sortable: true },
                { text: "Name", value: "name", sortable: true },
                { text: "Email", value: "email", sortable: true },
                { text: "Phone", value: "phone", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            options: { rowsPerPage: 10, page: 1 },

            listUser: []
        }),

        computed: {

            filteredSearch: function() {
                return this.listUser.filter((userFilter) => {
                    
                    const filter = this.filter.fastSearch.toLowerCase();

                    const profileName = userFilter.profileName.toLowerCase().match(filter)
                    const name = userFilter.name.toLowerCase().match(filter)
                    const email = userFilter.email.toLowerCase().match(filter)
                    const phone = userFilter.phone.toLowerCase().match(filter)
                    const id = userFilter.id.toString().match(filter);

                    if(profileName != null) { return profileName; } 
                    else if(name != null) { return name; } 
                    else if(email != null) { return email; } 
                    else if(phone != null) { return phone; } 
                    else { return id; }
                });
            }
        },

        methods: {

            getStatusColor (statusDescription) {

                let color = "";

                switch (statusDescription.toString().toUpperCase()) {

                    case "ACTIVE":
                        color = 'var(--color__main)';
                        break;

                    case "INACTIVE":
                        color = 'var(--color__cinza_escuro)';
                        break;

                    case "PASSWORD RESET REQUEST":
                        color = 'var(--color__status_password_reset_request)';
                        break;

                    case "PASSWORD RESET REQUEST - IN APPROVAL":
                        color = 'var(--color__status_password_reset_request_in_approval)';
                        break;

                    case "PASSWORD RESET REQUEST - APPROVED":
                        color = 'var(--color__main)';
                        break;
                
                    default:
                        break;
                }

                return color
            },

            async getRegisters() {

                this.listUser = await this.$store.dispatch("userModule/List");
            },

            confirmCancel(id) {

                this.statusId = 0;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will INACTIVATE this user in the system, confirm your decision?',
                    methodConfirm: this.cancel,
                    params: id
                };

            },

            async cancel(id) {

                this.showLoading();
                let statusId = this.statusId;

                let result = await this.$store.dispatch("userModule/UpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            },

            confirmActive(id) {

                this.statusId = 1;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will ACTIVATE this user in the system, confirm your decision?',
                    methodConfirm: this.active,
                    params: id
                };

            },

            async active(id) {

                this.showLoading();
                let statusId = this.statusId;

                let result = await this.$store.dispatch("userModule/UpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            },

            confirmApprove(id) {

                this.statusId = 4;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will APPROVE this user to reset their password, confirm your decision?',
                    methodConfirm: this.approve,
                    params: id
                };

            },

            async approve(id) {

                this.showLoading();
                let statusId = this.statusId;

                let result = await this.$store.dispatch("userModule/UpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            },

            confirmResetPassword(id) {

                this.statusId = 4;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will APPROVE this user to reset their password, confirm your decision?',
                    methodConfirm: this.resetPassword,
                    params: id
                };

            },

            async resetPassword(id) {

                this.showLoading();
                let statusId = this.statusId;

                let result = await this.$store.dispatch("userModule/UpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            }
        },

        async created() {
            this.showLoading();
            await this.getRegisters();
            this.hideLoading();
        }
    })
</script>
